import React, { Component } from "react";
import { connect } from "dva";
import { Modal, Button, Spin } from "antd";
import moment from "moment";
import SelectUserVersion4 from "nbugs-select-user-result-v4.0";
import RangeSelectUser from "nbugs-select-user-range-v4.0";
import styles from "./index.less";

const selectRuleList = ["", "学生", "教职工"];

@connect(({ createActivity }) => ({
  ...createActivity
}))
class PublishModal extends Component {
  componentDidMount() {}

  hideModal = () => {
    const { dispatch, handleCancel } = this.props;
    handleCancel();
    dispatch({
      type: "createActivity/save",
      payload: { publishModalVisible: false }
    });
  };

  render() {
    const {
      scopeSelectId,
      publishModalVisible,
      values,
      handleOk,
      spinProps,
      formData,
      orgType
    } = this.props;
    const { spinning } = spinProps;
    const {
      publisher,
      authoritySelectId = "",
      endDate,
      messageRemindFlag,
      isTiming,
      selectRuleType,
      cycleRemindTaskId,
      selectType
    } = values;

    const selectUserProps = {
      multiple: true,
      selectType: "dept",
      strictOrgRel: true,
      showTabList: ["orgRel"],
      selectSignature: scopeSelectId,
      isSaveSelectSignature: true,
      requestParams: {
        strictUser: true,
        selectTypeList: ["org_rel"]
      }
    };

    const remindMessage = {
      0: "不提醒",
      1: "全部人员",
      2: "新增人员"
    };

    return (
      <Modal
        title="发布"
        visible={publishModalVisible}
        className={styles["publish-modal"]}
        width={650}
        centered
        maskClosable={false}
        onCancel={this.hideModal}
        footer={[
          <Button onClick={this.hideModal}>取消</Button>,
          <Button type="primary" onClick={() => handleOk()} disabled={spinning}>
            {isTiming ? "确认保存" : "确认发布"}
          </Button>
        ]}
      >
        <Spin {...spinProps}>
          {scopeSelectId && (selectType === 0 || selectType === 2) && (
            <SelectUserVersion4
              selectUserProps={selectUserProps}
              key={scopeSelectId}
            />
          )}
          {scopeSelectId && selectType === 1 && (
            <RangeSelectUser
              selectSignature={scopeSelectId}
              key={scopeSelectId}
            />
          )}
          {selectRuleType && !!selectRuleType.length && orgType !== 'school' && (
            <div className="sendTarget">
              <span>发送对象：</span>
              <span>
                {selectRuleType.length === 1
                  ? selectRuleList[selectRuleType[0]]
                  : "学生、教职工"}
              </span>
            </div>
          )}
          <div className="attribute">
            <div className="title">属性</div>
            <div className="attribute-container">
              <div className="attribute-item">
                <span>发布者：</span>
                <span>{publisher}</span>
              </div>
              {authoritySelectId && (
                <div className="attribute-item">
                  <span>相同权限人：</span>
                  <span>已选</span>
                </div>
              )}
              {endDate && (
                <div className="attribute-item">
                  <span>打卡截止时间：</span>
                  <span>{moment(endDate).format("YYYY.MM.DD HH:mm")}</span>
                </div>
              )}
              {cycleRemindTaskId ? (
                <div className="attribute-item">
                  <span>未打卡提醒设置：</span>
                  <span>已设置</span>
                </div>
              ) : null}
              {isTiming ? (
                <div className="attribute-item">
                  <span>定时发送：</span>
                  <span>是</span>
                </div>
              ) : null}
              {formData.hasIndex ? (
                <div className="attribute-item">
                  <span>增加打卡明细：</span>
                  <span>是</span>
                </div>
              ) : null}
              <div className="attribute-item">
                <span>消息提醒：</span>
                <span>{remindMessage[messageRemindFlag]}</span>
              </div>
            </div>
          </div>
        </Spin>
      </Modal>
    );
  }
}
export default PublishModal;
